import { type FC } from 'react';
import { Button } from 'src/components/buttons-and-actions/button';
import { ExternalLink } from 'src/components/navigation/link';
import { useProductFruitsEnabled } from 'src/components/product-fruits/use-product-fruits-enabled';
import { openProductFruitsFeedbackModal } from 'src/components/product-fruits/utils';

export const NewDesignToggle: FC = () => {
  return (
    <div
      data-testid="new-design-toggle"
      className={`
        grid items-center justify-between gap-md bg-background-surface-subdued
        px-2xl py-xl
        md:grid-cols-[1fr_auto]
        print:hidden
      `}
    >
      <div>
        <span>
          New PRISMA Platform design - clearer workflow, better experience. Read
          the{' '}
          <ExternalLink
            className="legacy:underline"
            href="https://www.prisma-capacity.eu/news/insights/a-fresh-look-for-the-prisma-platform"
            target="_blank"
          >
            summary of all changes
          </ExternalLink>
          .{' '}
          {useProductFruitsEnabled() && (
            <>
              You can leave Feedback in our{' '}
              <Button
                mode="link"
                className="legacy:underline"
                onClick={openProductFruitsFeedbackModal}
              >
                feedback form
              </Button>
              .
            </>
          )}
        </span>
      </div>
    </div>
  );
};
